<div class="content">

    <div class="header">{{ 'bikeshop.shop_profile.collections.default_slots' | translate }}</div>

    <!-- <div class="row margin-top-16">
      <div class="col-md-4 label" [ngClass]="{invalid: !data.slotName}">{{ 'bikeshop.shop_profile.collections.name' |
        translate }}</div>
      <div class="col-md-8">
        <input type="text" pInputText [(ngModel)]="data.slotName" />
      </div>
    </div> -->

    <div class="row margin-top-16">
        <div class="col-md-4 label" style="margin-top: 0px;"
            [ngClass]="{invalid: !(data.dayOfWeek >= 0 && data.dayOfWeek < 7)}">{{
            'bikeshop.shop_profile.collections.select_slot_day' | translate }}
            <div *ngIf="!data.id">
                <small>{{'bikeshop.shop_profile.collections.select_slot_day_info' | translate}}</small>
            </div>
        </div>
        <div class="col-md-8 days">
            <div *ngFor="let day of days">
                <div *ngIf="!data.id || data.dayOfWeek === day">
                    <div>
                        <p-radioButton name="DayOfTheWeek" [value]="day" [(ngModel)]="data.dayOfWeek"
                            [disabled]="data.id">
                        </p-radioButton>
                    </div>
                    <div class="label">{{ dayOfWeek(day) }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{invalid: !data.slotStartTime}">{{
            'bikeshop.shop_profile.collections.slot_start_time' | translate }}</div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-calendar [(ngModel)]="data.slotStartTime" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly">
                </p-calendar>
            </div>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{invalid: !data.slotEndTime || data.slotEndTime <= data.slotStartTime}">
            {{
            'bikeshop.shop_profile.collections.slot_end_time' | translate }}</div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-calendar [(ngModel)]="data.slotEndTime" [timeOnly]="true" [hourFormat]="'12'"
                    inputId="timeonly"></p-calendar>
            </div>
        </div>
    </div>

    <div *ngIf="isWorkshop">
        <div class="row margin-top-16">
            <div class="col-md-4 label">{{ 'bikeshop.shop_profile.collections.can_do_collections' | translate }}</div>
            <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="data.canDoCollection"></p-inputSwitch>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 label">{{ 'bikeshop.shop_profile.collections.can_do_deliveries' | translate }}</div>
            <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="data.canDoDelivery"></p-inputSwitch>
            </div>
        </div>
    </div>
    <div *ngIf="isRentals">
        <div class="row margin-top-16">
            <div class="col-md-4 label">{{ 'bikeshop.shop_profile.collections.can_do_deliveries' | translate }}</div>
            <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="data.canDoDelivery"></p-inputSwitch>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 label">{{ 'bikeshop.shop_profile.collections.can_do_collections' | translate }}</div>
            <div class="col-md-2">
                <p-inputSwitch [(ngModel)]="data.canDoCollection"></p-inputSwitch>
            </div>
        </div>
    </div>

</div>

<div class="content">
    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{invalid: !(data.bufferDays >= 0)}">{{
            'bikeshop.shop_profile.collections.buffer_days' | translate }} -
            ({{data.bufferDays}} {{ 'bikeshop.users.days' |
            translate }})
        </div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-slider [(ngModel)]="data.bufferDays" [min]="0" [max]="6"></p-slider>
            </div>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label"
            [ngClass]="{invalid: !data.cutOffTime || (data.bufferDays === 0 && data.cutOffTime >= data.slotStartTime) ? true : false}">
            {{
            'bikeshop.shop_profile.collections.cut_off_time' | translate }}</div>
        <div class="col-md-3 flex">
            <div style="width: 100%">
                <p-calendar [(ngModel)]="data.cutOffTime" [timeOnly]="true" [hourFormat]="'12'"
                    inputId="timeonly"></p-calendar>
            </div>
        </div>
    </div>

    <div class="row margin-top-16"
        *ngIf="(data.dayOfWeek >= 0 && data.dayOfWeek < 7) && data.bufferDays >= 0 && data.cutOffTime">
        <div class="col-md-4 label"></div>
        <div class="col-md-8 bold">
            <div>
                {{ 'bikeshop.shop_profile.collections.cut_off_time_config_explanation' | translate : {
                selectedDay:
                dayOfWeek(data.dayOfWeek), cutOffTime: formatCutOffTime(data.cutOffTime), cutOffDay:
                dayOfWeek(getBufferDay(data.dayOfWeek, data.bufferDays))
                } }}
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="row">
        <div class="col-md-4 label" style="margin-top: 0px;"
            [ngClass]="{invalid: !selectedVehicles || selectedVehicles.length === 0}">{{
            'bikeshop.shop_profile.collections.linked_vehicles' | translate }}</div>
        <div class="col-md-8 partners">
            <div *ngFor="let vehicle of vehicles">
                <div>
                    <p-checkbox name="linkedVehicles" value="{{vehicle.id}}" [(ngModel)]="selectedVehicles"
                        (onChange)="clearAreas(vehicle, $event)"></p-checkbox>
                </div>
                <div class="label">{{vehicle.name}} (<span
                        *ngFor="let area of vehicle.linkedAreas; let i = index">{{area.areaName}}{{i ===
                        vehicle.linkedAreas.length - 1 ? '' : ','}} </span>)
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="row">
        <div class="col-md-4 label" style="margin-top: 0px;"
            [ngClass]="{invalid: !selectedAreas || selectedAreas.length === 0}">{{
            'bikeshop.shop_profile.collections.linked_areas' | translate }}</div>
        <div class="col-md-8 partners">
            <div *ngFor="let area of areas">
                <div>
                    <p-checkbox name="linkedAreas" value="{{area.id}}" [(ngModel)]="selectedAreas"
                        [disabled]="!canAreaBeSelected(area)"></p-checkbox>
                </div>
                <div class="label" [ngStyle]="{'opacity': canAreaBeSelected(area) ? 1 : 0.5}">{{area.areaName}}</div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="content">
  <div class="row">
    <div class="col-md-4 label" style="margin-top: 0px;"
      [ngClass]="{invalid: !selectedPartners || selectedPartners.length === 0}">{{
      'bikeshop.shop_profile.collections.link_to_stores' | translate }}</div>
    <div class="col-md-4 partners">
      <div *ngFor="let partner of linkedPartners">
        <div>
          <p-checkbox name="linkedPartners" value="{{partner.partnerID}}" [(ngModel)]="selectedPartners"
            [disabled]="linkedPartners.length === 1"></p-checkbox>
        </div>
        <div class="label">{{partner.partnerName}}</div>
      </div>
    </div>
  </div>
</div> -->

<div class="content">
    <div class="row margin-bottom-16" *ngIf="!valid()">
        <div class="col-md-12 invalid">{{ 'bikeshop.shop_profile.collections.validation_message' | translate }}</div>
    </div>

    <div class="row">
        <div class="col-md-8 label"></div>
        <div class="col-md-4">
            <button pButton (click)="save()" class="p-button-raised full-width p-mini" [ngClass]="{'busy': saving}"
                label="{{ (saving ? 'bikeshop.general.busy' : data.id ? 'bikeshop.general.update' : 'bikeshop.general.save') | translate}}"
                [disabled]="saving || !valid()"></button>
        </div>
    </div>
</div>